



































































import Vue from 'vue';
import VueCompositionAPI, {defineComponent, computed, ref, watch} from '@vue/composition-api';
import {useSolutionViews} from '@components/solution-views/solution-views';
import {mapToPoiItem} from './mapToPoiItem';
import {
  Activity,
  CandidatePoiItem,
  ConstraintType,
  getBeginningOfTheDay,
  getNextDay,
  Timeslot,
  UserActivityCategoryEnum,
} from '@mobi-components/global-solution';

import {PoiItem, POIDetailsView, Offer, LunchTime} from './POIDetailsView';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import {VueWithModal} from '@components/solution-views/summary-filters';
import {
  addManualActivity,
  downloadRecommendationAlternatives,
  getManualActivities,
  getSessionId,
  getSolutionTimezone,
  getStartEndDates,
  getTripId,
  removePOIFromSolution,
  updateSolution,
} from '@/store/state/helpers';
import {getAvailableTimeSlots} from '@/store/api/download-available-timeslots';
import {generateEmptyActivityItem, ProblmSubmissionRoute} from '@/store/state/global.types';
import {RoutingCategory, useDetailsHeader} from '@components/solution-views/details-header-handler';
import {RouterAliases} from '@/router/routerAliases';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import {fixDate} from '@/store/state/fix-solution-dates';
import ExtLinkIcon from '@components/svg/external-link.vue';
import {getCandidatePoiItem} from '@components/solution-views/explore-view/group-management';
import {trackBtnClick, trackDetailsView} from '@/store/api/trackBtnClick';
import {getUserId} from '@/services/auth-shared';
import {formatPrices} from '@mobi-components/amex-bluesky-components';
import {fetchAdditionalPois} from '@/store/api/fetch-additional-pois';
import {AdditionalPoisModule} from '@/store/modules';
import {useSavedPlaces} from '../saved-places/savedPlaces';
import {getFormattedPoiCardDayDescription} from '../exp-list/utils';
import {ItineraryListModule} from '@/store/modules/itinerary-list';

Vue.use(VueCompositionAPI);

export default defineComponent({
  components: {
    POIDetailsView,
    PoweredByMobiFooter,
    ExtLinkIcon,
  },
  setup(_, {root}) {
    const {
      backToSummaryView,
      headerIcons,
      onSelectDetailsView,
      onShowPoiDetailsFromMap,
      solution,
      destinationName,
      solutionDatesRange,
      isStaysOn,
      selectedPoiId,
      activityForSelectedPoiId,
      activeSolutionFilters,
      getPoiForSelectedItem,
      isLoading,
      sourceAlternatives,
    } = useSolutionViews(root as VueWithModal);
    const {onOpenCategory, onOpenRoute} = useDetailsHeader();
    const slotsMap = ref<Map<string, [number, number]>>(new Map());
    const contextName = computed(() => {
      return destinationName.value;
    });

    const {savedPoiIds} = useSavedPlaces();

    const openBooking = (url: string) => {
      window.open(url, '_blank');
    };

    const selectedActivities = computed(() => {
      return savedPoiIds.value;
    });

    const isPoiSelected = (poiId: string) => {
      return selectedActivities.value.has(poiId);
    };

    const isPoiSchedulled = (poiId: string) => {
      return !!ItineraryListModule.getDayById(poiId, contextName.value);
    };

    const getDayForActivity = (activity?: Activity | null) => {
      if (!activity) {
        return '';
      }
      return ItineraryListModule.getDayById(activity.id, contextName.value)?.label || '';
    };

    const dayDetails = computed(() => {
      const category = selectedPoiItem.value?.categories.find(Boolean) || UserActivityCategoryEnum.NONE;
      const day = getDayForActivity(activityForSelectedPoiId.value);
      return getFormattedPoiCardDayDescription(activityForSelectedPoiId.value?.name || '', category, day);
    });

    const isDetailsLoading = ref(true);

    const rooms = ref<Offer[]>([]);

    const alternatives = computed(() => {
      return (
        (sourceAlternatives.value?.response?.results || []).map((res) => {
          return {
            ...res,
            img: res.images[1],
            tags:
              // @ts-ignore-next-line
              res.tags?.map((name: string) => {
                return {name};
              }) || [],
          };
        }) || []
      ).filter((alt) => alt.name !== selectedActivity.value?.name);
    });

    const selectedDayLabel = computed(() => {
      return getDayForActivity(activityForSelectedPoiId.value);
    });

    const droppedActivity = computed<CandidatePoiItem | null>(() => {
      const candidate = solution.value?.dropped_activities.find((x) => {
        const candidate = getCandidatePoiItem(x.candidate_information);
        return candidate?.id === selectedPoiId.value;
      });

      return (candidate ? getCandidatePoiItem(candidate.candidate_information) : null) as CandidatePoiItem;
    });

    const bookingUrl = computed(() => {
      return activityForSelectedPoiId.value?.source?.content?.booking_url;
    });
    const webURL = computed(() => {
      return activityForSelectedPoiId.value?.source?.content?.url;
    });

    const selectedActivity = computed<CandidatePoiItem | null>(() => {
      const source = getPoiForSelectedItem.value;
      let poi = mapToPoiItem(source as CandidatePoiItem, activeSolutionFilters.value);
      poi = poi || mapToPoiItem(source as CandidatePoiItem, activeSolutionFilters.value);

      if (!poi) {
        return null;
      }
      return source;
    });

    const selectedPoiItem = computed<PoiItem | null>(() => {
      if (!selectedActivity.value) {
        return null;
      }
      // @ts-ignore
      rooms.value = selectedActivity.value.offers || [];
      return mapToPoiItem(selectedActivity.value, activeSolutionFilters.value);
    });

    const getRoomPrice = (room: Offer) => {
      return formatPrices(room.prices).labels['USD'];
    };
    const getBgImg = (room: Offer) => {
      // console.log(`url("${room.images.small}")`);
      // url('${activityImg.value}')`
      return `url('${room.images.small}')`;
    };

    const getTimeSlots = async () => {
      if (!selectedActivity.value) {
        return [];
      }
      try {
        const goalItem = generateEmptyActivityItem(
          selectedActivity.value.id,
          selectedActivity.value.name,
          selectedActivity.value.categories[0] as UserActivityCategoryEnum,
          ConstraintType.NOT_APPLICABLE,
          1800,
        );
        goalItem.candidate_information = {
          candidates: [{...selectedActivity.value, price: undefined, tags: [], images: {medium: '', small: ''}}],
          search: null,
          selection: null,
        };

        const timeslots = await getAvailableTimeSlots(goalItem, getSessionId());
        const timezone = selectedActivity.value.location.time_zone;
        const adjustedSlots = timeslots.map((x) => {
          const start = fixDate(x[0], timezone);
          const end = fixDate(x[1], timezone);
          return [start, end];
        });
        slotsMap.value = new Map(
          adjustedSlots.map((x, i) => {
            return [`${x[0]}-${x[1]}`, timeslots[i]];
          }),
        );
        return adjustedSlots;
      } catch {}
    };

    const isAddAllowed = computed(() => {
      return (
        !selectedActivities.value.has(selectedActivity.value?.id || '') &&
        !selectedActivities.value.has(selectedActivity.value?.source_id || '')
      );
    });

    const isRemoveAllowed = computed(() => {
      const isHotel = (selectedActivity.value?.categories || []).some(
        (x) => x === UserActivityCategoryEnum.ACCOMMODATION,
      );
      // not possible to add, then we can remove it, and should not be a hotel
      return !isAddAllowed.value && !isHotel;
    });

    const loadAlternatives = async () => {
      if (!selectedPoiId.value) return;

      isDetailsLoading.value = true;
      const alt = await downloadRecommendationAlternatives(selectedPoiId.value);
      const pois = await fetchAdditionalPois([...(alt?.results?.map((res) => res.id) || []), selectedPoiId.value]);

      if (pois && pois.length) {
        AdditionalPoisModule.addPois(pois);
      }

      isDetailsLoading.value = false;
    };

    const category = computed<RoutingCategory | null>(() => {
      const allowedCategories = [
        UserActivityCategoryEnum.ACCOMMODATION,
        UserActivityCategoryEnum.EXPERIENCE,
        UserActivityCategoryEnum.DINING,
      ];
      const category =
        (selectedActivity.value?.categories?.length && selectedActivity.value.categories[0]) ||
        UserActivityCategoryEnum.NONE;
      const isAllowed = allowedCategories.includes(category);
      return isAllowed ? (category as RoutingCategory) : null;
    });

    const isStay = computed(() => {
      return category.value === UserActivityCategoryEnum.ACCOMMODATION;
    });

    const isBookingBtnAvailable = computed(() => {
      // if it is a stay and bookingURL available and stays On, then we can book it
      // if it's not a stay and booking URL available, then we can book it
      if (isStay.value) {
        return bookingUrl.value && isStaysOn.value;
      }
      return Boolean(bookingUrl.value);
    });

    loadAlternatives();
    const trackView = () => {
      const userId = getUserId();
      if (selectedPoiId.value && category.value) {
        trackDetailsView(userId, category.value, selectedPoiId.value, solution.value?.problem_id);
      }
    };

    // trackView();

    watch(selectedPoiId, () => {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      loadAlternatives();
      trackView();
    });

    const onItemRemove = (id: string) => {
      removePOIFromSolution(id || '', true);
    };

    const saveExperience = async (alternativeHotelId: string, startTime: number, endTime: number) => {
      const poi = alternatives.value.find((x) => x.id === alternativeHotelId);
      const selected = alternativeHotelId === selectedActivity.value?.id ? selectedActivity.value : poi;

      if (selected) {
        // @ts-ignore
        selected.start_timestamp = startTime;
        // @ts-ignore
        selected.end_timestamp = endTime;
        // @ts-ignore
        addManualActivity(selected);
      }
    };

    const addExperience = async (activity: Activity | null, startTime = 0, endTime = 0, lunchTime = LunchTime.ANY) => {
      if (!activity) {
        return;
      }
      const selected = activity.source?.content || activity;
      // @ts-ignore
      selected.start_timestamp = startTime;
      // @ts-ignore
      selected.end_timestamp = endTime;

      const days = solutionDatesRange.value;
      try {
        // @ts-ignore
        await addManualActivity({...selected, timezone: getSolutionTimezone()});
        days.forEach((x) => {
          root.$emit('day-loading', {day: x.label, name: activity.name});
        });
        if (!startTime && !endTime) {
          root.$emit('day-loading', {day: 'stay', name: activity.name});
        }
        const newTripId = getTripId();
        await updateSolution(newTripId, ProblmSubmissionRoute.SOLUTION, [], lunchTime);
      } catch {
      } finally {
        days.forEach((x) => {
          root.$emit('day-loaded', x.label);
        });
        root.$emit('day-loaded', 'stay');
      }
    };

    const onRescheduleClick = async ({timeslot, lunchTime}: {timeslot: Timeslot | null; lunchTime: LunchTime}) => {
      // const dates: number[] = (solution.value?.activities || [])
      //   // @ts-ignore
      //   .map((x) => [x.original_start_time, x.original_end_time])
      //   .flat();
      // const min = Math.min(...dates) || 0;
      // const max = Math.max(...dates) || 0;
      const {start, end} = getStartEndDates();
      const date = timeslot || [Math.round(start / 1000), Math.round(end / 1000)];
      const relatedSlot = date;
      const startTime = getBeginningOfTheDay(new Date(relatedSlot[0] * 1000)).valueOf();
      const endTime = getNextDay(new Date(relatedSlot[1] * 1000)).valueOf();
      return addExperience(activityForSelectedPoiId.value, startTime, endTime, lunchTime);
    };

    const onAddItemFromDetailsView = async ({
      timeslot,
      poiId: poiIdToAdd,
    }: {
      timeslot: Timeslot | null;
      poiId: string;
    }) => {
      if (!poiIdToAdd) {
        return;
      }
      // const dates: number[] = (solution.value?.activities || [])
      //   // @ts-ignore
      //   .map((x) => [x.original_start_time, x.original_end_time])
      //   .flat();
      const {start, end} = getStartEndDates();
      // const min = Math.min(...dates) || 0;
      // const max = Math.max(...dates) || 0;
      const date = timeslot || [Math.round(start / 1000), Math.round(end / 1000)];
      const relatedSlot = date;
      const startTime = getBeginningOfTheDay(new Date(relatedSlot[1] * 1000)).valueOf();
      const endTime = getNextDay(new Date(relatedSlot[1] * 1000)).valueOf();
      return saveExperience(poiIdToAdd, startTime, endTime);
    };

    const backToExplore = () => {
      if (category.value) {
        onOpenCategory({cat: category.value});
      } else {
        onOpenRoute(RouterAliases.SUMMARY_VIEW);
      }
    };

    const trackBooking = () => {
      const userId = getUserId();
      trackBtnClick(userId, selectedPoiItem.value?.booking_url || selectedPoiItem.value?.url || '');
    };

    return {
      headerIcons,
      onSelectDetailsView,
      backToSummaryView,
      exploreCategory: UserActivityCategoryEnum.EXPERIENCE,
      onShowPoiDetailsFromMap,
      selectedDayLabel,
      isDetailsLoading,
      selectedPoiItem,
      sourceAlternatives,
      alternatives,
      getTimeSlots,
      onItemRemove,
      onAddItemFromDetailsView,
      isRemoveAllowed,
      isAddAllowed,
      destinationName,
      solutionDatesRange,
      backToExplore,
      openBooking,
      bookingUrl,
      webURL,
      isFooterAvailable: process.env.VUE_APP_IS_FOOTER_VISIBLE || false,
      trackBooking,
      isBookingBtnAvailable,
      rooms,
      getRoomPrice,
      getBgImg,
      isLoading,
      droppedActivity,
      isPoiSelected,
      isPoiSchedulled,
      selectedPoiId,
      dayDetails,
      onRescheduleClick,
      savedPoiIds,
    };
  },
});
